import { motion } from "framer-motion";
import { Reveal, Label } from "./Reveal";
import { STEPS } from "./content";

export const Process = () => (
  <section id="process" className="relative mx-auto max-w-7xl px-5 py-28 sm:px-8 sm:py-36" data-testid="process-section">
    <div className="grid gap-10 lg:grid-cols-12">
      <Reveal className="lg:col-span-4">
        <Label>How it works</Label>
        <h2 className="font-serif-d mt-5 text-5xl leading-[0.95] text-white sm:text-6xl">
          Four steps.<br /><span className="italic text-slate-400">Zero fluff.</span>
        </h2>
        <p className="mt-6 max-w-sm text-base leading-relaxed text-slate-300">
          You do the part only you can do: tell us what really happened. We do the rest.
        </p>
      </Reveal>
      <ol className="lg:col-span-8">
        {STEPS.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.08}>
            <motion.li whileHover={{ x: 8 }} transition={{ type: "spring", stiffness: 260, damping: 22 }}
              data-testid={`process-step-${s.n}`}
              className="group grid grid-cols-[auto_1fr] gap-6 border-t border-white/10 py-9 sm:grid-cols-[110px_220px_1fr] sm:gap-8">
              <span className="font-mono-d text-sm text-[var(--teal)]">{s.n}</span>
              <h3 className="font-serif-d text-3xl text-white transition-colors duration-300 group-hover:text-[var(--teal)] sm:text-4xl">{s.title}</h3>
              <p className="col-span-2 text-base leading-relaxed text-slate-300 sm:col-span-1">{s.text}</p>
            </motion.li>
          </Reveal>
        ))}
      </ol>
    </div>
  </section>
);
